import { Location, useLocation, useParams } from "react-router-dom"
import UploadDialog from "./UploadDialog";
import { Vehicle } from "../../../state/types";

/**
 * This wrapper allows a vehicle object to be passed in cleanly
 */
const UploadDialogWrapper = () => {
    const location: Location = useLocation()
    const vehicle = location.state?.vehicle

    if (!vehicle) {
        throw Error('No vehicle passed in.')
    }

    return <UploadDialog vehicle={vehicle} />
}

export default UploadDialogWrapper